module.exports = __webpack_public_path__ + "img/banner16.fb0bda87.png";